import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Footer from './Footer';

export default function PageFooter({
    children,
    className,
    ...props
}) {
    const classes = classNames(className);
    return (
        <div {...props} className={classes}>
            {children || <Footer />}
        </div>
    );
}

PageFooter.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
